<div mat-dialog-title class="change-site-state">
  Split Site
  <div class="close-icon-container" (click)="onNoClick()">
    <fa-icon [icon]="['far', 'xmark']" class="gray"></fa-icon>
  </div>
</div>
<mat-divider></mat-divider>
<div mat-dialog-content>
  <p>
    Upload one or more KML/KMZ files for the new split sites. Optionally create an additional site for any leftover
    area not covered by the uploaded files.
  </p>
  <form [formGroup]="kmlDocSelectForm" class="site-form">
    <div class="kml-upload-button-container">
      <ng-container>
        <fc-datepicker
          [minDate]="minEffectiveDate"
          [maxDate]="maxEffectiveDate"
          formControlName="effectiveDate"
          formFieldClass="w-100-1"
          inputID="effectiveDate"
          label="Effective Date"></fc-datepicker>
      </ng-container>
      <mat-checkbox formControlName="createLeftover">Create a site with the leftover area</mat-checkbox>
      <ng-container>
        <button
          (click)="onClickKmlUpload()"
          class="kml-button"
          data-cy="kml-upload-button"
          color="primary"
          mat-raised-button
          type="button">
          {{ displayedFileNames.length > 0 ? 'Re-' : '' }}Upload KML
        </button>
      </ng-container>
      @if (displayedFileNames.length > 0) {
        <p class="kml-file-name">Selected files: {{ displayedFileNames.toString() }}</p>
      }
    </div>
    <input
      #kmlFileUpload
      accept=".kml,.kmz"
      id="kmlFileUpload"
      name="kmlFileUpload"
      style="display: none"
      multiple
      type="file" />
  </form>
</div>
<div mat-dialog-actions>
  <button
    data-cy="button-yes"
    mat-raised-button
    color="primary"
    [disabled]="!this.kmlDocSelectForm.valid || this.parsedKml.length == 0"
    class="green-shadow-button"
    (click)="applyKML()">
    Apply
  </button>
</div>
